var map = {
	"./SendSmsVideo.mp4": 39095,
	"./ZohoCRMSendSmsVideo.mp4": 72577,
	"./hello_sendSmsGuidePipedrive.mp4": 57409,
	"./ringcentral.mp4": 99636,
	"./ringcentralSmsGuidePipedrive.mp4": 46105,
	"./twilio.mp4": 7149,
	"./twilioSmsGuidePipedrive.mp4": 90346
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24505;